import AssetDocuments from "./AssetDocuments";

export default function OrgDocuments() {
  return (
    <AssetDocuments
      ownerType="ORG"
      ownerId={null}
      title="Documenti aziendali"
      addPath="new"
      editPath={(id) => `${id}/edit`}
    />
  );
}
